<div class="flex flex-row w-full">
  <div class="m-2 mb-1">
    <span class="text-gray-700 text-base block font-normal uppercase mb-1">
      {{item.vehicle_name}} <span *ngIf="item.taggable">- {{item.taggable.taggable_name}}</span> {{item.tagAttrValue('Type')}}
      <lib-badge [dotColor]="item.stateColor" color="gray" [showDot]="true">
              <span class="capitalize block">{{item.stateText}}</span>
    </lib-badge>
    </span>
    <div class="flex flex-row items-baseline mb-1">
      <div *ngIf="item.realtime.previous_poi" title="Dernière Adresse" class="flex flex-row items-baseline py-1">
        <span [ngStyle]="{'border-left': '5px solid ' + item.realtime.previous_poi.color}"
              class="text-gray-700 text-sm block font-normal mr-1 pl-2">{{item.realtime.previous_poi.name}}</span>
        <span class="text-gray-600 text-xs font-normal mr-1">
          (<span title="Distance">{{item.realtime.previous_poi_distance | number}}m - </span>
          <span
            [title]="'Temps d\'arrêt ' + (item.realtime.previous_poi_enter_time | date:'yyyy-MM-dd HH:mm:ss') + '-' + (item.realtime.previous_poi_exit_time | date:'yyyy-MM-dd HH:mm:ss')">
            {{item.realtime.previous_poi_duration_human}}</span>)
        </span>
        <span class="text-gray-700 text-sm block font-normal mr-1"> &#8594; </span>
      </div>
      <div *ngIf="item.realtime.current_poi; else noCurrent" title="Adresse Actuelle"
           class="flex flex-row items-baseline py-1">
        <span [ngStyle]="{'border-left': '5px solid ' + item.realtime.current_poi.color}"
              class="text-gray-700 text-sm block font-normal mr-1 pl-2">{{item.realtime.current_poi.name}}</span>
        <span class="text-gray-600 text-xs font-normal mr-1">
          (<span title="Distance">{{item.realtime.current_poi_distance | number}}m - </span>
          <span [title]="'Date d\'entrer ' + (item.realtime.current_poi_enter_time | date:'yyyy-MM-dd HH:mm:ss')">
            {{item.realtime.current_poi_duration_human}}</span>)
        </span>
      </div>
      <ng-template #noCurrent><span title="À l'adresse suivante"
                                    class="text-gray-600 text-sm font-normal block mr-1">{{item.last_stop_elapsed_duration_human}}</span>
      </ng-template>
    </div>
    <div class="flex flex-row w-full text-xs text-gray-500">
      <p [title]="item.duration_human">{{item.start_time | date:'yyyy-MM-dd HH:mm:ss'}}</p>
      <p class="px-1">•</p>
      <p>{{item.domain_name}}</p>
      <p class="px-1">•</p>
      <p>{{item.metrics.length_in_km | number}} km</p>
      <p class="px-1">•</p>
      <p>{{item.metrics.speed_avg | number}} km/h</p>
      <p class="px-1">•</p>
      <p>{{item.metrics.fuel_total_consumption | number}} L</p>
      <p class="px-1">•</p>
      <p>{{item.metrics.fuel_hourly_consumption_rate_avg | number}} L/h</p>
      <p class="px-1">•</p>
      <p>{{item.metrics.fuel_temperature_avg | number}} °C</p>
      <!--<ng-container *ngFor="let a of item.tag_attributes">
        <p class="px-1">•</p>
        <p>{{a.name}}: {{a.value}}</p>
      </ng-container>-->
    </div>
  </div>
</div>
